import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import { api, ApiError, type MeResponse } from "./types"

/**
 * Single shared /api/me query. Cached in TanStack so every consumer hits the
 * same in-memory copy — RequireAuth, AppShell, page-level conditionals all
 * reuse it instead of duplicating fetches.
 */
export function useMe(): UseQueryResult<MeResponse, ApiError> {
  return useQuery<MeResponse, ApiError>({
    queryKey: ["me"],
    queryFn: () => api<MeResponse>("/api/me"),
    retry: (failureCount, err) => {
      if (err instanceof ApiError && (err.status === 401 || err.status === 503)) return false
      return failureCount < 1
    },
  })
}
